<template>
  <div class="user-manage">
    <div class="form-container">
      <div class="flex">
        <el-input class="gray" clearable v-model="form.username" placeholder="请输入姓名"></el-input>
        <el-button class="btn-blue" @click="searchList">搜索</el-button>
      </div>
      <el-button class="btn-blue" @click="openDialog">新增</el-button>
    </div>
    <div class="table-container">
      <div class="table">
        <el-table :data="userList" style="width: 100%">
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="username" label="用户名"></el-table-column>
          <el-table-column prop="status" label="是否启用">
            <template slot-scope="scope">
              <el-switch
                @change="updateStatus($event,scope.row.id)"
                v-model="scope.row.status"
                active-color="#2e68ea"
                inactive-color="#D5D5D6"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                :disabled="scope.row.status===0"
                class="btn-text"
                type="text"
                @click="updateUser(scope.row)"
              >编辑</el-button>
              <el-button
                :disabled="scope.row.status===0"
                class="btn-text"
                type="text"
                @click="toUserAuthority(scope.row.id,scope.row.name)"
              >权限设置</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="dialogTitle" top="35vh" :visible.sync="userDialog" width="380px">
      <div class="border"></div>
      <el-form ref="userForm" :rules="userFormRules" :model="userForm" label-width="80px">
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="userForm.name" class="white" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="用户名：" prop="username">
          <el-input v-model="userForm.username" class="white" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码：" prop="password">
          <el-input v-model="userForm.password" class="white" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="submitForm('userForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UserManage from "models/user-manage";
const userManage = new UserManage();
export default {
  data() {
    return {
      form: {
        username: ""
      },
      searchForm: {
        username: ""
      },
      userList: [],
      dialogTitle: "新增",
      userDialog: false,
      userForm: {
        id: "",
        name: "",
        username: "",
        password: ""
      },
      userFormRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      }
    };
  },
  watch: {
    userDialog: {
      handler(newVal) {
        if (!newVal) {
          this.userForm.id = "";
          this.userForm.name = "";
          this.userForm.username = "";
          this.userForm.password = "";
          this.userFormRules.password[0].required = true;
          this.dialogTitle = "新增";
        }
      }
    }
  },
  created() {
    this.getUserList();
  },
  methods: {
    //获取管理员列表
    getUserList() {
      let name = this.searchForm.username;
      userManage.getManagerList(name).then(res => {
        if (res.success) {
          let userList = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            obj.username = value.username;
            obj.status = value.status;
            userList.push(obj);
          });
          this.userList = userList;
        }
      });
    },
    searchList() {
      this.searchForm = this.form;
      this.getUserList();
    },
    //修改状态
    updateStatus(value, id) {
      let data = {
        id
      };
      userManage.postUpdateManagerStatus(data).then(res => {
        if (res.success) {
          this.getUserList();
        }
      });
    },
    //显示弹窗
    openDialog() {
      this.userDialog = true;
    },
    //关闭弹窗
    closeDialog() {
      this.userDialog = false;
    },
    //编辑
    updateUser(row) {
      this.userDialog = true;
      this.dialogTitle = "编辑";
      this.userForm.id = row.id;
      this.userForm.name = row.name;
      this.userForm.username = row.username;
      this.userFormRules.password[0].required = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.userForm.id) {
            let data = {};
            data.id = this.userForm.id;
            data.name = this.userForm.name;
            data.username = this.userForm.username;
            data.password = this.userForm.password;
            userManage.postUpdateManager(data).then(res => {
              if (res.success) {
                this.getUserList();
                this.closeDialog();
                this.$message.success("编辑成功");
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let data = {};
            data.name = this.userForm.name;
            data.username = this.userForm.username;
            data.password = this.userForm.password;
            userManage.postAddManager(data).then(res => {
              if (res.success) {
                this.getUserList();
                this.closeDialog();
                this.$message.success("新增成功");
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    toUserAuthority(id, name) {
      this.$router.push(`/system-settings/user-manage/user-authority?id=${id}&name=${name}`);
    }
  }
};
</script>
<style lang="scss" scoped>
.user-manage {
  flex: 1;
  display: flex;
  flex-direction: column;
  .form-container {
    padding: 16px;
    background: #fff;
    margin-bottom: 16px;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    .flex {
      display: flex;
      .btn-blue {
        margin-left: 16px;
      }
    }
  }
  .table-container {
    min-height: 500px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    .table {
      .is-disabled {
        color: #999999;
      }
    }
  }
  .el-dialog {
    .el-form {
      padding: 0 20px 20px 20px;
    }
    .dialog-footer {
      padding-top: 16px;
      border-top: 1px solid #eeeeee;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
